import { TradeLeaderboardRecordWithComputedEventsSchema } from "../hub";
import { BalancedRuleSimulationDataSchema, TradingCampaignRules } from "./trade-to-earn-rules";
import z from "zod";

const baseSimulationSchema = {
  records: TradeLeaderboardRecordWithComputedEventsSchema.array(),
  simulationData: z.record(z.string(), z.any()),
};

export const GaussianLeaderboardSimulationDataSchema = z.object({
  rule: z.literal(TradingCampaignRules.GAUSSIAN),
  records: TradeLeaderboardRecordWithComputedEventsSchema.array(),
  simulationData: BalancedRuleSimulationDataSchema,
});

export const LeaderboardSimulateResponseSchema = z.discriminatedUnion("rule", [
  GaussianLeaderboardSimulationDataSchema,
  z.object({ rule: z.literal(TradingCampaignRules.FIXED_PER_VOLUME), ...baseSimulationSchema }),
  z.object({ rule: z.literal(TradingCampaignRules.PRIZE_BY_SLOT), ...baseSimulationSchema }),
  z.object({ rule: z.literal(TradingCampaignRules.PROPORTIONAL), ...baseSimulationSchema }),
  z.object({ rule: z.literal(TradingCampaignRules.PROPORTIONAL_V2), ...baseSimulationSchema }),
  z.object({ rule: z.literal(TradingCampaignRules.SPREAD_TRADES_OVER_TIME), ...baseSimulationSchema }),
  z.object({ rule: z.literal(TradingCampaignRules.CUSTOM), ...baseSimulationSchema }),
  z.object({ rule: z.literal(TradingCampaignRules.PVP), ...baseSimulationSchema }),
  z.object({ rule: z.literal(TradingCampaignRules.STAIRS), ...baseSimulationSchema }),
  z.object({ rule: z.literal(TradingCampaignRules.PNL), ...baseSimulationSchema }),
  z.object({ rule: z.literal(TradingCampaignRules.POWER), ...baseSimulationSchema }),
]);

export type LeaderboardSimulateResponse = z.infer<typeof LeaderboardSimulateResponseSchema>;
